import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { EnvironmentService } from '../environment.service';
import { QuestionnaireService } from '../questionnaire/questionnaire.service';

@Injectable()
export class ExperimentsService {
  private Experiments() {
    return {
      defaultValue: 'Null',
      LLC_ATTY_GUIDED_TEST_V2: {
        cookie_name: 'LLC_ATTY_GUIDED_TEST_V2',
        ctrl: 'LLC_ATTY_GUIDED_TEST_V2_CTRL',
        expa: 'LLC_ATTY_GUIDED_TEST_V2_EXPA',
        notintest: 'LLC_ATTY_GUIDED_TEST_V2_NOT_IN_TEST'
      },
      LLC_TAX_PILOT_TEST: {
        cookie_name: 'LLC_TAX_PILOT_TEST',
        ctrl: 'LLC_TAX_PILOT_CONTROL',
        expa: 'LLC_TAX_PILOT_EXPERIMENT',
        notintest: 'LLC_TAX_PILOT_EXPERIMENT_NOT_IN_TEST'
      },
      LZ_LLC_ON_API_RAMPUP: {
        cookie_name: 'LZ_LLC_ON_API_RAMPUP',
        ctrl: 'LZ_LLC_ON_API_RAMPUP_CTRL',
        expa: 'LZ_LLC_ON_API_RAMPUP_VAR1',
        notintest: 'LZ_LLC_ON_API_RAMPUP_NOT_IN_TEST'
      },
      LZ_LLC_WITH_GLO_RAMPUP: {
        cookie_name: 'LZ_LLC_WITH_GLO_RAMPUP',
        ctrl: 'LZ_LLC_WITH_GLO_RAMPUP_CTRL',
        expa: 'LZ_LLC_WITH_GLO_RAMPUP_VAR1',
        notintest: 'LZ_LLC_WITH_GLO_RAMPUP_NOT_IN_TEST'
      }
    };
  }

  constructor(private environmentService: EnvironmentService, private cookieService: CookieService, private questionnaireService: QuestionnaireService) {}

  // Commenting this out first before removing it completely
  public GetBFunnelTestValue() {
    return this.Experiments().defaultValue;
  }

  public GetBShowPriceTestValue() {
    return this.Experiments().defaultValue;
  }

  public GetBShowPriceTest1Value() {
    // Tax Pilot Test - B-58124
    if (
      this.questionnaireService.llc.bShowPriceTest1 &&
      (this.questionnaireService.llc.bShowPriceTest1 === this.Experiments().LLC_TAX_PILOT_TEST.ctrl || this.questionnaireService.llc.bShowPriceTest1 === this.Experiments().LLC_TAX_PILOT_TEST.expa)
    ) {
      return this.questionnaireService.llc.bShowPriceTest1;
    }
    return this.cookieService.get(this.Experiments().LLC_TAX_PILOT_TEST.cookie_name) ? this.cookieService.get(this.Experiments().LLC_TAX_PILOT_TEST.cookie_name) : 'Null';
  }

  // Commenting this out first before removing it completely
  public GetBFunnelTestValueForQ2Crosssells() {
    return this.Experiments().defaultValue;
  }
  public GetBShowPriceTestValueForQ2Crosssells() {
    if (
      this.questionnaireService.llc.bShowPriceTest &&
      (this.questionnaireService.llc.bShowPriceTest === this.Experiments().LZ_LLC_ON_API_RAMPUP.ctrl || this.questionnaireService.llc.bShowPriceTest === this.Experiments().LZ_LLC_ON_API_RAMPUP.expa)
    ) {
      return this.questionnaireService.llc.bShowPriceTest;
    }
    return this.Experiments().defaultValue;
  }

  public GetBShowPriceTest1ValueForQ2Crosssells() {
    if (
      this.questionnaireService.llc.bShowPriceTest1 &&
      (this.questionnaireService.llc.bShowPriceTest1 === this.Experiments().LLC_TAX_PILOT_TEST.ctrl || this.questionnaireService.llc.bShowPriceTest1 === this.Experiments().LLC_TAX_PILOT_TEST.expa)
    ) {
      return this.questionnaireService.llc.bShowPriceTest1;
    }
    return this.Experiments().defaultValue;
  }

  /**
   * Functions used for checking which experiment is currently active
   */

  public isE2EZeroPriceTest_ExpA(): boolean {
    return false;
  }

  public isLLCTaxPilotTest_CTRL(): boolean {
    return CookieService.prototype.get('LLC_TAX_PILOT_TEST') === this.Experiments().LLC_TAX_PILOT_TEST.ctrl;
  }

  public isLLCTaxPilotTest_EXPA(): boolean {
    return CookieService.prototype.get('LLC_TAX_PILOT_TEST') === this.Experiments().LLC_TAX_PILOT_TEST.expa;
  }

  public getExperimentName(): string {
    if (
      this.questionnaireService.llc.bShowPriceTest1 &&
      (this.questionnaireService.llc.bShowPriceTest1 === this.Experiments().LLC_TAX_PILOT_TEST.ctrl || this.questionnaireService.llc.bShowPriceTest1 === this.Experiments().LLC_TAX_PILOT_TEST.expa)
    ) {
      return this.questionnaireService.llc.bShowPriceTest1;
    } else {
      return this.Experiments().LLC_TAX_PILOT_TEST.notintest;
    }
  }
  /** End Region */

  // todo: remove for 12/28 release

  public getGloExperimentName(): string {
    return this.getGloDesignTest() ? this.Experiments().LZ_LLC_WITH_GLO_RAMPUP.expa : this.Experiments().LZ_LLC_WITH_GLO_RAMPUP.ctrl;
  }

  public setGloDesignTest(value?: boolean) {
    if (value) {
      window.sessionStorage.setItem('lzGloDesignTest', value.toString());
    } else {
      window.sessionStorage.removeItem('lzGloDesignTest');
    }
  }
  public getGloDesignTest(): boolean {
    return this.environmentService.useGloTheme() || window.sessionStorage.getItem('lzGloDesignTest') === 'true' || new URLSearchParams(window.location.search).get('gloDesignTest') === 'true';
  }
}
